module.exports = __webpack_public_path__ + "static/media/3S.471f3e59.svg";